import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const http = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export const inr2 = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const pctOff = (p) => (p.mrp > p.price ? Math.round(((p.mrp - p.price) / p.mrp) * 100) : 0);

export const itemKey = (x) => (x.variant ? `${x.slug}:${x.variant}` : x.slug);

export const lineTax = (x) => (x.gst_exclusive ? (x.price * x.qty * x.gst_rate) / 100 : 0);

export const buildLabel = (m) => (m === 0 ? "No build needed" : `${m} min build`);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return (d[0]?.msg || "Please check the form").replace("Value error, ", "");
  return d || "Something went wrong. Please try again.";
};

const get = (url, params) => http.get(url, { params }).then((r) => r.data);

export const useProducts = (params = {}) =>
  useQuery({ queryKey: ["products", params], queryFn: () => get("/products", params) });

export const useProduct = (slug) =>
  useQuery({ queryKey: ["product", slug], queryFn: () => get(`/products/${slug}`), enabled: !!slug, retry: (n, e) => e?.response?.status !== 404 && n < 2 });

export const useCategories = () => useQuery({ queryKey: ["categories"], queryFn: () => get("/categories") });

export const useReviews = (slug) =>
  useQuery({ queryKey: ["reviews", slug], queryFn: () => get(`/products/${slug}/reviews`) });

export const CATEGORY_NAMES = {
  storage: "Modular storage",
  modules: "Add-on modules",
};

export const STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana",
  "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
  "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
  "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands", "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry",
];
